module.exports = __webpack_public_path__ + "media/svg/ai_edit-6cf14936.svg";